import custom from './custom';
import promoteJobs from './promoteJobs';
import promoteContentShares from './promoteContentShares';
import gamificationUpdate from './gamificationUpdate';

export default [
  custom,
  gamificationUpdate,
  promoteJobs,
  promoteContentShares,
];



// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/push/index.js